const cs = {
    "global.form.action.ok": "OK",
    "global.form.action.store": "Uložit",
    "global.form.action.yes": "Ano",
    "global.form.action.create": "Založit",
    "global.form.action.close": "Zavřít",
    "global.form.action.cancel": "Storno",

    "global.form.title.error.required": "Pole je povinné",

    "global.form.title.contains.required.fields": "Položky označené * jsou povinné",

    "global.json.error.unknown": "Chyba",
    "global.json.error.500": "Chyba",
    "global.json.error.404": "Požadovaný objekt nebyl nalezen",

    "global.days.today": "dnes",
    "global.days.short.mon": "po",
    "global.days.short.tue": "út",
    "global.days.short.wed": "st",
    "global.days.short.thu": "čt",
    "global.days.short.fri": "pá",
    "global.days.short.sat": "so",
    "global.days.short.sun": "ne",

    "adresa.form.title.ulice": "Ulice",
    "adresa.form.title.cisloOrientacni": "Č. orientační",
    "adresa.form.title.cisloOrientacniPismeno": "Písmeno čísla orientačního",
    "adresa.form.title.castObce": "Část obce",
    "adresa.form.title.cisloDomovni": "Č. domovní",
    "adresa.form.title.cisloDomovniZnak": "Znak čísla domovního",
    "adresa.form.title.mestCast": "Městská část",
    "adresa.form.title.obec": "Obec",
    "adresa.form.title.psc": "PSČ",
    "adresa.form.title.posta": "Doručovací pošta",
    "adresa.form.title.okres": "Okres",
    "adresa.form.title.kraj": "Kraj",
    "adresa.form.title.stat": "Stát",
    "adresa.form.title.overenaAdresa": "Ověření",
    "adresa.form.title.overenaAdresa.overeno": "Ověřeno",
    "adresa.form.title.overenaAdresa.overeno.tooltip": "Adresa je ověřená oproti registru",
    "adresa.form.title.overenaAdresa.neovereno": "Neověřeno",
    "adresa.form.title.overenaAdresa.neovereno.tooltip": "Adresa není ověřená oproti registru",
    "adresa.form.title": "Adresa",
    "adresa.form.action.ztotozniAdresu.title.neztotozneno": "Adresu se nepodařilo podle zadaných údajů ověřit, doplňte nebo upravte údaje o adrese",
    "adresa.form.action.ztotozniAdresu": "Ověřit",
    "adresa.form.action.ztotozniAdresu.tooltip": "Ověřit adresu oproti registru",
    "adresa.form.validation.noCr.obec.required": "V případě adresy mimo ČR je položka obec povinná.",
    "adresa.form.validation.cr.obec.required": "V případě adresy v ČR je položka obec povinná.",
    "adresa.form.validation.cr.common.required": "V případě adresy v ČR musí být vyplněno číslo domovní nebo ulice a číslo orientační.",

    "subjekt.form.title.subjektDokladIdentif": "Č. OP",
    "subjekt.form.title.titulPred": "Titul před",
    "subjekt.form.title.jmeno": "Jméno",
    "subjekt.form.title.prijmeni": "Příjmení",
    "subjekt.form.title.titulZa": "Titul za",
    "subjekt.form.title.datumNarozeni": "Datum narození",
    "subjekt.form.title.adresaTrvpobytSidlo": "Adresa",
    "subjekt.form.title.kontaktVychTelefon": "Telefon",
    "subjekt.form.title.kontaktVychEmail": "Email",
    "subjekt.form.title.kontaktVychDs": "Datová schránka",
    "subjekt.form.title.kontaktVychOsoba": "Kontaktní osoba",
    "subjekt.form.title.nazev": "Název",
    "subjekt.form.title.ico": "IČO",
    "subjekt.form.title.cisPravniForma": "Právní forma",
    "subjekt.form.title.overit.none": "Nebyl nalezen žádný záznam",
    "subjekt.form.title.overit.none.description": "Dle zadaných vstupních podmínek nebyl nalezen žádný záznam. Zkontrolujte zadané údaje a akci případně zopakujte.",
    "subjekt.form.title.overit.many": "Bylo nalezeno více záznamů",
    "subjekt.form.title.overit.many.description": "Proveďte upřesnění zadání a akci opakujte.",
    "subjekt.form.action.overit": "Ověřit",
    "subjekt.form.action.overit.tooltip": "Ověřit oproti registru",

    "subjekt.typSubjekt.FO": "Fyzická osoba",
    "subjekt.typSubjekt.PO": "Právnická osoba",
    "subjekt.typSubjekt.FOP": "Podnikající fyzická osoba",

    "dateTimePicker.calendarButton": "Vybrat datum",
    "dateTimePicker.timeButton": "Vybrat čas",
}
module.exports = cs;
